import * as React from "react";
const SvgLightBulb = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.33333 13.8821V15.8333C8.33333 16.7538 9.07953 17.5 10 17.5C10.9205 17.5 11.6667 16.7538 11.6667 15.8333V13.8821M10 2.5V3.33333M3.33333 10H2.5M4.66675 4.66675L4.16667 4.16667M15 4.66675L15.5002 4.16667M17.5 10H16.6667M14.1667 10C14.1667 12.3012 12.3012 14.1667 10 14.1667C7.69881 14.1667 5.83333 12.3012 5.83333 10C5.83333 7.69881 7.69881 5.83333 10 5.83333C12.3012 5.83333 14.1667 7.69881 14.1667 10Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgLightBulb;
